import Tracked from 'editor/utils/Tracked';
import { CanvasSourceRaw } from 'mapbox-gl';
import { v4 as uuidv4 } from 'uuid';

interface MapboxCanvasSourceTracked extends Record<string, unknown> {
  source: CanvasSourceRaw;
}

class MapboxCanvasSource extends Tracked<MapboxCanvasSourceTracked> {
  id: string;

  added = false;

  updatedFields = new Set();

  constructor(source: CanvasSourceRaw) {
    super({ source });
    this.id = uuidv4();

    this.tracked.source = source;
  }

  didUpdate(prop: string): void {
    this.updatedFields.add(prop);
  }

  getSource(): CanvasSourceRaw {
    return this.tracked.source;
  }

  getCanvas(): HTMLCanvasElement {
    const { canvas: canvasOrSelector } = this.tracked
      ?.source as CanvasSourceRaw;

    if (canvasOrSelector instanceof HTMLCanvasElement) {
      return canvasOrSelector;
    }

    const canvas = document.querySelector<HTMLCanvasElement>(canvasOrSelector);

    if (!canvas) {
      throw new Error(
        'MapboxCanvasSource.getCanvas(): unable to locate canvas element specified in source'
      );
    }

    return canvas;
  }
}

export default MapboxCanvasSource;
